import { useState, useEffect } from 'react';
import { Title } from '../../../component/title/Title';
import Modal from '../../../component/modal/Modal.component';
import GridComponent from '../../../component/grid/GridComponent.component';
import { getGroups, deleteGroups, putGroups, postGroups } from './Groups.service';
import Form from './form/Form.component';
import Table from '../../../component/table/Table.component';
import { ACTION_DELETE, ACTION, Action, ACTION_EDIT_SUBMIT } from '../../../component/table/interfaces/TableInterface';
import ModalDelete from '../../../component/modal/ModalDelete.component';
import { useSnackbar } from '../../../context/Snackbar';
import Group from './interfaces/Group';
import { Pagination } from "../../../component/table/interfaces/Pagination";
import { INITIAL_PAGINATION } from '../../../component/table/component/pagination/utils/Pagination';
import useModal from '../../../hooks/useModal';
import { INITIAL_VALUES } from './utils/INITIAL_VALUES';
import ButtonFormFull from '../../../component/buttton/ButtonFormFull.component';

export default function GroupComponent() {

    const { setSnackbar } = useSnackbar();
    const [open, addModal] = useModal();
    const [group, setGroup] = useState<Group[]>([]);
    const [request, setRequest] = useState<boolean>(true);
    const [total, setTotal] = useState<number>(0);
    const [pagination, setPagination] = useState<Pagination>(INITIAL_PAGINATION);

    useEffect(() => {
        getGroups(pagination).then(res => {
            setGroup(res.data.data);
            setTotal(res.data.total);
        }).catch((error) => {
            console.log('Erro ao consultar Grupos', error);
        }).finally(() => {
            setRequest(false);
        });
    }, [request, pagination]);

    const handleChangePage = (_event: unknown, newPage: number) => {
        setPagination({ ...pagination, page: newPage + 1 });
    };

    const registerGroups = async (group: Group) => {
        try {
            await (group.id ? putGroups(group) : postGroups(group));
            setSnackbar({ msg: `Grupo foi ${group.id ? 'atualizado' : 'cadastrado'} com sucesso!`, type: 'success' });
            addModal(false);
            setRequest(true);
        } catch (error) {
            console.log('Erro ao submeter grupo!', error);
            setSnackbar({ msg: `Erro ao ${group.id ? 'atualizar' : 'cadastrar'} grupo!`, type: 'error' });
        }
    }

    const handleClickAction = (action: Action, group: Group) => {
        if (action === ACTION_EDIT_SUBMIT) {
            return registerGroups(group);
        }
        if (action === ACTION_DELETE) {
            return addModal(group.id);
        }
    };

    const handleClickDelete = async () => {
        await deleteGroups(Number(open)).then(res => {
            setSnackbar({ msg: "Grupo excluído com sucesso!", type: 'success' });
            setRequest(true);
        }).catch(error => {
            console.log('Erro ao excluir grupo!', error);
            setSnackbar({ msg: "Erro ao excluir grupo!", type: 'error' });
        }).finally(function () {
            addModal(undefined);
        });
    };

    return (
        <>
            <GridComponent justify="space-between">
                <Title>GRUPOS</Title>
                <Modal title="Criar Grupo" open={open === true} handleClick={() => addModal(!open)}  >
                    <Form initialValues={INITIAL_VALUES} handleSubmitForm={registerGroups}  >
                        <ButtonFormFull disabled={request} onClick={() => addModal(false)} />
                    </Form>
                </Modal>

            </GridComponent>
            <ModalDelete open={!!open && open !== true} handleClick={() => addModal(undefined)} onClickSubmit={handleClickDelete} title="Confirma a exclusão desse grupo?" />
            <br />
            <br />
            <Table
                request={request}
                data={group}
                size={total}
                headCells={[{ id: 'nome', label: 'Nome do Grupo' }, { id: ACTION, label: 'Ação' }]}
                page={pagination.page}
                onChangePage={handleChangePage}
                editable
                noActionView
                handleClickAction={handleClickAction}
            />
        </>
    );
}
